export default "/WebApp/dist/assets/svg/pin.svg";